export const consentTargets = ["buttonPlaceOrder_before"];
//# sourceMappingURL=ConsentTarget.types.js.map